import { render, staticRenderFns } from "./LiveEndCenter.vue?vue&type=template&id=995f1234&scoped=true"
import script from "./LiveEndCenter.vue?vue&type=script&lang=js"
export * from "./LiveEndCenter.vue?vue&type=script&lang=js"
import style0 from "./LiveEndCenter.vue?vue&type=style&index=0&id=995f1234&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995f1234",
  null
  
)

export default component.exports